// const Home = () => {
//   const [counterOn, setCounterOn] = useState(false);
//   const [scrollPosition, setScrollPosition] = useState(0);
//   const [currentSectionIndex, setCurrentSectionIndex] = useState(0);
//   const [finalText, setFinalText] = useState(null);
//   const [details, setDetails] = useState();

//   let sum3UserAccessToken = localStorage.getItem("sum3UserAccessToken");
//   let sum3UserRole = localStorage.getItem("sum3UserRole");

//   const handleScroll = () => {
//     setScrollPosition(window.scrollY / 1000);
//   };

//   const [homeTop, setHomeTop] = useState();
//   const [checkSelf, setCheckSelf] = useState();
//   const [counterCart, setCounterCart] = useState();
//   const [homeSecond, setHomeSecond] = useState();
//   const [participate, setParticipate] = useState();
//   const [partner, setPartner] = useState();
//   const [portfolio, setPortfolio] = useState();
//   const [saving, setSaving] = useState();
//   const [services, setServices] = useState();
//   const [what, setWhat] = useState();
//   const [why, setWhy] = useState();

//   useEffect(() => {
//     setHomeTop(details?.homeTop);
//     setCheckSelf(details?.checkSelf);
//     setCounterCart(details?.counterCart);
//     setHomeSecond(details?.homeSecond);
//     setParticipate(details?.participate);
//     setPartner(details?.partner);
//     setPortfolio(details?.portfolio);
//     setSaving(details?.saving);
//     setServices(details?.services);
//     setWhat(details?.what);
//     setWhy(details?.why);
//   }, [details]);

//   const getPageDetails = async () => {
//     try {
//       const response = await fetch(`${API}/content/home/all`, {
//         method: "get",
//         headers: {
//           Accept: "*/*",
//           "Content-Type": "application/json",
//         },
//       });
//       const data = await response.json();
//       if (!response.ok) {
//         throw new Error(data?.message);
//       }
//       setDetails(data?.payload);
//     } catch (error) {
//       Swal.fire({
//         text: error,
//         icon: "error",
//       });
//     }
//   };
//   useEffect(() => {
//     getPageDetails();
//   }, []);

//   useEffect(() => {
//     window.addEventListener("scroll", handleScroll);
//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);
//   useEffect(() => {
//     AOS.init({ duration: 2000 });
//   }, []);

//   const navigate = useNavigate();
//   return (
//     <div>
//       <div className="homeHero" id="home1">
//         <div class=" col-11 m-auto">
//           <p
//             class="mfs-7  fwt"
//             data-aos="fade-in"
//             dangerouslySetInnerHTML={{ __html: homeTop?.title }}
//           ></p>
//           <div className="mfs-7 fweb org">
//             <Typewriter
//               options={{
//                 strings: homeTop?.text,
//                 autoStart: true,
//                 loop: true, // No looping
//                 delay: 200,
//                 cursor: "", // Hides the blinking cursor after typing
//               }}
//             />
//           </div>
//           {!sum3UserAccessToken && !sum3UserRole && (
//             <button
//               class="sumBtn mfs-4 rounded-5 mt-3"
//               onClick={() => navigate("/log-in")}
//             >
//               Log in
//             </button>
//           )}
//           <div class="arrows">
//             <p class="d1 fs-1">
//               <i class="bi bi-caret-down-fill"></i>{" "}
//             </p>
//             <p class="d2 fs-1">
//               <i class="bi bi-caret-down-fill"></i>{" "}
//             </p>
//             <p class="d3 fs-1">
//               <i class="bi bi-caret-down-fill"></i>{" "}
//             </p>
//           </div>
//         </div>
//       </div>

//       {/* <div class='position-relative'>
//                 <HomeScroll />
//             </div> */}

//       <div class="servicePc mt-5 " id="home3">
//         <Services />
//       </div>

//       <div class="serviceMobile" id="home4">
//         <ServiceSmall />
//       </div>

//       <div class="homeAboutPC" id="home5">
//         <HomeAbout2 />
//       </div>
//       <div class="homeAboutMB" id="home6">
//         <HomeAbout3 />
//       </div>

//       {/* <div class='row col-11 m-auto gap-lg-0 gap-5 mt-3' id='home7'>
//                 {counterCart?.map((el) => {
//                     return (
//                         <div class='col-lg-4'  >
//                             <div class='col-11  rounded-top-5 h-100 text-start p-2 m-auto' style={{ background: '#f2f2f2' }}>
//                                 <div class='col-11 m-auto'>
//                                     <p class='mfs-6 fwm my-3' dangerouslySetInnerHTML={{ __html: el?.title }}></p>
//                                 </div>
//                                 <div class='text-end d-flex align-items-center justify-content-end mfs-8 '>
//                                     <ScrollTrigger onEnter={() => setCounterOn(true)} onExit={() => setCounterOn(false)}>
//                                         <p class='mfs-8 fwsb'  ><span  >{counterOn && <CountUp start={0} end={el.text} delay={0} />}</span></p>
//                                     </ScrollTrigger>
//                                     <p class='fwsb'>
//                                         {el?.extra}+
//                                     </p>
//                                 </div>

//                             </div>
//                         </div>
//                     )
//                 })}
//             </div> */}

//       <div class="row col-11 m-auto gap-lg-0 gap-5 mt-3" id="home7">
//         {counterCart?.map((el) => {
//           return (
//             <div class="col-lg-4">
//               <div
//                 class="col-11  rounded-top-5 h-100 text-start p-2 m-auto"
//                 style={{ background: "#f2f2f2" }}
//               >
//                 <div class=" d-flex align-items-center  mfs-8 ">
//                   <ScrollTrigger
//                     onEnter={() => setCounterOn(true)}
//                     onExit={() => setCounterOn(false)}
//                   >
//                     <p class="mfs-8 fwsb">
//                       <span>
//                         {counterOn && (
//                           <CountUp start={0} end={el.text} delay={0} />
//                         )}
//                       </span>
//                     </p>
//                   </ScrollTrigger>
//                   <p class="fwsb">{el?.extra}+</p>
//                 </div>
//                 <div class="col-11 m-auto text-end">
//                   <p
//                     class="mfs-6 fwm my-3 text-end"
//                     dangerouslySetInnerHTML={{ __html: el?.title }}
//                   ></p>
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>

//       <div
//         class="col-11 m-auto my-5  bg-blackGray rounded-4"
//         id="home8"
//         style={{ overflow: "hidden" }}
//       >
//         <br />
//         <div class="text-start text-white">
//           <div class="col-11 m-auto text-start text-white">
//             <div class="col-md-6 text-start fbnr ">
//               <p class="mfs-7 fbnr fweb"> Our Partners</p>
//             </div>
//           </div>

//           <div class="ourPartnerPc">
//             <ParallaxProvider>
//               <Parallax translateX={[-50, 50]}>
//                 <div class="d-flex gap-4 mt-4">
//                   {partner?.ideas1?.map((e) => {
//                     return (
//                       <button class="btn btn-outline-light fbnt rounded-5 fs-4 text-nowrap px-5 fwm ">
//                         {e}
//                       </button>
//                     );
//                   })}
//                 </div>
//               </Parallax>
//             </ParallaxProvider>
//             <ParallaxProvider>
//               <Parallax translateX={[50, -50]}>
//                 <div class="d-flex gap-4 mt-4 justify-content-end">
//                   {partner?.ideas2?.map((e) => {
//                     return (
//                       <button class="btn btn-outline-light fbnt rounded-5 fs-4 text-nowrap px-5 fwm ">
//                         {e}
//                       </button>
//                     );
//                   })}
//                 </div>
//               </Parallax>
//             </ParallaxProvider>
//           </div>

//           <div class="ourPartnerMb ">
//             <div class="marquee">
//               <div class="marquee__item">
//                 <>
//                   {partner?.ideas1?.map((e) => {
//                     return (
//                       <button class="btn btn-outline-light fbnt rounded-5 mx-3 fs-4 text-nowrap px-5 fwm ">
//                         {e}
//                       </button>
//                     );
//                   })}
//                   {partner?.ideas2?.map((e) => {
//                     return (
//                       <button class="btn btn-outline-light fbnt mx-3 rounded-5 fs-4 text-nowrap px-5 fwm ">
//                         {e}
//                       </button>
//                     );
//                   })}
//                 </>
//               </div>
//             </div>
//           </div>

//           <div class="col-11 m-auto">
//             {!sum3UserAccessToken && !sum3UserRole && (
//               <button
//                 class="sumBtn mfs-4 rounded-5 mt-3"
//                 onClick={() => navigate("/log-in")}
//               >
//                 Log in
//               </button>
//             )}
//             {/* <button class='sumBtn mfs-4 mt-5  rounded-5' onClick={() => navigate('/log-in')}>Log in</button> */}
//             <br />
//           </div>
//         </div>
//         <br />
//       </div>
//       <div class="col-11 m-auto home9 my-5" id="home9">
//         <p class="fbnh mfs-7 org fwh">
//           Why risk your entire capital for the sake of minor savings?
//         </p>
//         <p class="fs-5 tJustify col-lg-6 col-md-8 col-11 m-auto">
//           {" "}
//           At 3Sum, we focus on what truly matters—your growth, your safety, and
//           your success. Let’s build something substantial together.
//         </p>
//       </div>
//       <div id="home10">
//         <HomeFooterTop2 />
//         {/* <div class="col-11 m-auto">
//                     <div class='col-lg-8 col-md-9 col-11 m-auto mt-5'>
//                         <p class='fbnh mfs-7 org fweb  '  >Level up your portfolio with us.</p>
//                     </div>
//                     <div class='d-flex align-items-center gap-4 flex-wrap'>
//                         {
//                             portfolio?.portText?.map((el)=>{
//                                 return(
//                                     <button class='sumBtn text-nowrap fs-4 rounded-5'>{el}</button>
//                                 )
//                             })
//                         }

//                     </div>
//                 </div> */}
//       </div>
//       {/* <br /> */}
//     </div>
//   );
// };

// export default Home;
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react";
import CountUp from "react-countup";
import { useNavigate } from "react-router-dom";
import { Parallax, ParallaxProvider } from "react-scroll-parallax";
import ScrollTrigger from "react-scroll-trigger";
import Swal from "sweetalert2";
import Typewriter from "typewriter-effect";
import "../../App.css";
import { API } from "../url";
import HomeAbout2 from "./HomeAbout2";
import HomeAbout3 from "./HomeAbout3";
import HomeFooterTop2 from "./HomeFooterTop2";
import HomeScroll from "./HomeScroll";
import ServiceSmall from "./ServiceSmall";
import Services from "./Services";
import "./home.css";

const Home = () => {
  const [counterOn, setCounterOn] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [currentSectionIndex, setCurrentSectionIndex] = useState(0);
  const [finalText, setFinalText] = useState(null);
  const [details, setDetails] = useState(null);

  let sum3UserAccessToken = localStorage.getItem("sum3UserAccessToken");
  let sum3UserRole = localStorage.getItem("sum3UserRole");

  const handleScroll = () => {
    setScrollPosition(window.scrollY / 1000);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  const getPageDetails = async () => {
    try {
      const response = await fetch(`${API}/content/home/all`, {
        method: "get",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data?.message);
      }
      setDetails(data?.payload);
    } catch (error) {
      Swal.fire({
        text: error,
        icon: "error",
      });
    }
  };

  useEffect(() => {
    getPageDetails();
  }, []);

  const navigate = useNavigate();

  return (
    <div>
      {/* Home Hero Section */}
      <div className="homeHero" id="home1">
        <div class=" col-11 m-auto">
          <p
            class="mfs-7 fwt"
            data-aos="fade-in"
            dangerouslySetInnerHTML={{ __html: details?.homeTop?.title }}
          ></p>
          <div className="mfs-7 fweb org">
            <Typewriter
              options={{
                strings: details?.homeTop?.text[0] ? JSON.parse(details?.homeTop?.text) : [],
                autoStart: true,
                loop: true,
                delay: 200,
                cursor: "",
              }}
            />
          </div>
          {!sum3UserAccessToken && !sum3UserRole && (
            <button
              class="sumBtn mfs-4 rounded-5 mt-3"
              onClick={() => navigate("/log-in")}
            >
              {details?.homeTop?.button_name || "Log in"}
            </button>
          )}
          <div class="arrows">
            <p class="d1 fs-1">
              <i class="bi bi-caret-down-fill"></i>{" "}
            </p>
            <p class="d2 fs-1">
              <i class="bi bi-caret-down-fill"></i>{" "}
            </p>
            <p class="d3 fs-1">
              <i class="bi bi-caret-down-fill"></i>{" "}
            </p>
          </div>
        </div>
      </div>
      {(details?.homeSecond.desktop_image != 'null' && !!details?.homeSecond.desktop_image) && ((!!details?.homeSecond.desktop_video  && details?.homeSecond.desktop_video != 'null') || (details?.homeSecond.desktop_youtube_link != 'null'&& !!details?.homeSecond.desktop_youtube_link)) ? <div class="position-relative homeAboutPC">
        <HomeScroll homeSecondData={details?.homeSecond} isDesktop={true} />{" "}
      </div> : ''}
      {(details?.homeSecond.mobile_image != 'null' && !!details?.homeSecond.mobile_image) && ((!!details?.homeSecond.mobile_video  && details?.homeSecond.mobile_video != 'null') || (details?.homeSecond.mobile_youtube_link != 'null'&& !!details?.homeSecond.mobile_youtube_link)) ? <div class="position-relative homeAboutMB">
        <HomeScroll homeSecondData={details?.homeSecond} isMobile={true} />{" "}
      </div> : ''}
      {/* Services Sections */}
      <div class="servicePc mt-5" id="home3">
        <Services servicesData={details?.services} />
      </div>
      <div class="serviceMobile" id="home4">
        <ServiceSmall servicesData={details?.services} />
      </div>
      {/* About Sections */}
      <div class="homeAboutPC" id="home5">
        <HomeAbout2
          whyData={details?.why}
          whatData={details?.what}
          checkSelfData={details?.checkSelf}
          participateData={details?.participate}
        />
      </div>
      <div class="homeAboutMB" id="home6">
        <HomeAbout3
          whyData={details?.why}
          whatData={details?.what}
          checkSelfData={details?.checkSelf}
          participateData={details?.participate}
        />
      </div>

      {/* Counter Section */}
      <div class="row col-11 m-auto gap-lg-0 gap-5 mt-3" id="home7">
        {details?.counterCart?.map((el) => {
          return (
            <div class="col-lg-4">
              <div
                class="col-11 rounded-top-5 h-100 text-start p-2 m-auto"
                style={{ background: "#f2f2f2" }}
              >
                <div class=" d-flex align-items-center mfs-8 ">
                  <ScrollTrigger
                    onEnter={() => setCounterOn(true)}
                    onExit={() => setCounterOn(false)}
                  >
                    <p class="mfs-8 fwsb">
                      <span>
                        {counterOn && (
                          <CountUp start={0} end={el.text} delay={0} />
                        )}
                      </span>
                    </p>
                  </ScrollTrigger>
                  <p class="fwsb">{el?.extra}+</p>
                </div>
                <div class="col-11 m-auto text-end">
                  <p
                    class="mfs-6 fwm my-3 text-end"
                    dangerouslySetInnerHTML={{ __html: el?.title }}
                  ></p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Partners Section */}
      <div
        class="col-11 m-auto my-5 bg-blackGray rounded-4"
        id="home8"
        style={{ overflow: "hidden" }}
      >
        <br />
        <div class="text-start text-white">
          <div class="col-11 m-auto text-start text-white">
            <div class="col-md-6 text-start fbnr ">
              <p class="mfs-7 fbnr fweb">{details?.partner?.title}</p>
            </div>
          </div>

          <div class="ourPartnerPc">
            <ParallaxProvider>
              <Parallax translateX={[-50, 50]}>
                <div class="d-flex gap-4 mt-4">
                  {details?.partner?.partners ? JSON.parse(details?.partner?.partners[0])?.slice(0, 4).map((e) => {
                    return (
                      <button class="btn btn-outline-light fbnt rounded-5 fs-4 text-nowrap px-5 fwm">
                        {e}
                      </button>
                    );
                  }) : ''}
                </div>
              </Parallax>
            </ParallaxProvider>
            <ParallaxProvider>
              <Parallax translateX={[50, -50]}>
                <div class="d-flex gap-4 mt-4 justify-content-end">
                  {details?.partner?.partners ? JSON.parse(details?.partner?.partners[0])?.slice(4).map((e) => {
                    return (
                      <button class="btn btn-outline-light fbnt rounded-5 fs-4 text-nowrap px-5 fwm">
                        {e}
                      </button>
                    );
                  }) : ''}
                </div>
              </Parallax>
            </ParallaxProvider>
          </div>

          <div class="ourPartnerMb ">
            <div class="marquee">
              <div class="marquee__item">
                <>
                  {details?.partner?.partners ? JSON.parse(details?.partner?.partners[0])?.map((e) => {
                    return (
                      <button class="btn btn-outline-light fbnt rounded-5 mx-3 fs-4 text-nowrap px-5 fwm">
                        {e}
                      </button>
                    );
                  }) : ''}
                </>
              </div>
            </div>
          </div>

          <div class="col-11 m-auto">
            {!sum3UserAccessToken && !sum3UserRole && (
              <button
                class="sumBtn mfs-4 rounded-5 mt-3"
                onClick={() => navigate("/log-in")}
              >
                Log in
              </button>
            )}
            <br />
          </div>
        </div>
        <br />
      </div>

      {/* Savings Section */}
      <div class="col-11 m-auto home9 my-5" id="home9">
        <p class="fbnh mfs-7 org fwh">{details?.saving?.title}</p>
        <p class="fs-5 tJustify col-lg-6 col-md-8 col-11 m-auto">
          {details?.saving?.text}
        </p>
      </div>

      {/* Footer Section */}
      <div id="home10">
        <HomeFooterTop2
          portfolioData={details?.portfolio}
          checkSelfData={details?.checkSelf}
          participateData={details?.participate}
        />
      </div>
    </div>
  );
};

export default Home;
